import { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import SignUpScreen from './SignUpScreen';
import SignInScreen from './SignInScreen';
import RedeemACodeScreen from './RedeemACodeScreen';
import SignInWithPromoScreen from './SignInWithPromoScreen';
import CookieConsent from 'react-cookie-consent';
import NoSubscription from './NoSubscription';
import Footer from './footer';
import TermsOfService from './TOS';
import ReactGA from 'react-ga';
import SubVerification from './SubVerification';
import { Helmet } from 'react-helmet';
import addEventToFirestore from './EventHelper';
import FAQComponent from './FAQ';
import EmailVerification from './pages/EmailVerificationScreen';
import PasswordReset from './pages/PasswordResetScreen';
import RenewSubscriptionScreen from './pages/RenewSubscription';
import MainDashboard from './NewDashboardComponents/MainDashboard';
import NewNavigationBar from './LandingPageComponents/NewNavigationBar';
import { ShootingStarButton } from './LandingPageComponents/ShootingStarButton';
import TitleAndSubtitle from './LandingPageComponents/TitleAndSubtitle';
import FullWidthVideo from './DashboardComponents/FullWidthVideo';
import ScrollingImages from './LandingPageComponents/ScrollingImages';
import NewsPage from './NewPagesComponents/NewsPage';
import HomePage from './NewPagesComponents/HomePage';
import UpdatesPage from './pages/UpdatesPage';
import CallToAction from './LandingPageComponents/CallToAction';
import NewPricingScreen from './NewPricingScreen';
import ContactPage from './NewPagesComponents/ContactPage';
import VladAccessPage from './NewPagesComponents/VladAccessPage';
import { InfiniteMovingCards } from './components/ui/infinite-moving-cards';
import UpdatedHistoricalFlowDashboard from './NewDashboardComponents/UpdatedHistoricalFlow';
import APIEmailCollectionComponent from './pages/ApiEmailCollectionPage';
import AffiliatePasswordScreen from './AffiliatePasswordScreen';
import { HeroHighlightComponent } from './components/ui/HeroHighlightComponent';
import TitleWithCards from './LandingPageComponents/TitleWithCards';
import AffiliateInfoPage from './pages/AffiliateInfoPage';
import LiveTickerDetails from './NewDashboardComponents/FlowUpperInfoComponents/LiveTickerDetails';
import ApiPortal from './ApiComponents/ApiPortal';
import CustomFlowWindowManager from './NewDashboardComponents/CustomFlowScreen';
import StockMiniChart from './NewDashboardComponents/MiniChartTesting';
import { Alert } from 'antd';
import { firestore } from './firebase';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import OnboardingCarousel from './NewDashboardComponents/OnboardingCarousel';
import VirtualizedFlowGrid from './NewDashboardComponents/VirtualizedFlowGrid';
import BullflowTrainingWithProgress from './NewDashboardComponents/BullflowAcademy';

ReactGA.initialize('G-YKZZT8E9J6');
ReactGA.pageview(window.location.pathname + window.location.search);

const cardItems = [
  {
    quote: '"Some big gains this AM thanks to $hood. Shoutout to @BullflowIO for the great flow alerts!"\n\n',
    name: "@mog_trade_",
    title: "Day Trader on X"
  },
  {
    quote: '"Also shoutout to @BullflowIO as well, for flagging all the $ARM flow and having an awesome yet surprisingly cheap options flow platform."',
    name: "@wrongtrade",
    title: "Investor on X"
  }, {
    quote: '"S/O to @BullflowIO for being the most affordable live options flow data platform on the market!" \n\n',
    name: "@josh_puharic",
    title: "Owner of Tidal Trades"
  }, {
    quote: '"whether we finish with a green candle today or not, liquidity seems to be flipping positive (green) on the daily timeframe! And all that spotted with @BullflowIO🙏"',
    name: "@i_kiok",
    title: "Trader on X"
  },


];
const App = () => {
  const navigate = useNavigate();
  const [hasError, setHasError] = useState(false);
  const [isDesktopOrLaptop, setIsDesktopOrLaptop] = useState(false);
  const [variant, setVariant] = useState('');

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    setIsDesktopOrLaptop(mediaQuery.matches);

    const handleResize = () => setIsDesktopOrLaptop(mediaQuery.matches);
    mediaQuery.addListener(handleResize);

    return () => {
      mediaQuery.removeListener(handleResize);
    };
  }, []);

  const handleError = async (message, source, lineno, colno, error) => {
    // 1. Normalize the incoming message so Firestore only ever sees strings
    let rawMessage = message;
    if (rawMessage && typeof rawMessage === 'object') {
      if ('message' in rawMessage) {
        error = rawMessage.error || error;
        rawMessage = rawMessage.message;
      } else {
        rawMessage = JSON.stringify(rawMessage);
      }
    }

    // 2. Build a proper error description
    const errorMessage = error?.message || rawMessage;
    const errorStack = error?.stack || 'No stack trace available';
    const location = `${source || 'unknown source'}:${lineno || 0}:${colno || 0}`;

    // 3. Console output for debugging
    console.error(
      `🛑 Unhandled error: ${errorMessage}\n` +
      `   at ${location}\n` +
      `${errorStack}`
    );

    // 4. Firestore payload
    const payload = {
      message: errorMessage,
      source: source || null,
      lineno: lineno || null,
      colno: colno || null,
      stack: errorStack,
      timestamp: serverTimestamp(),
      user: 'Unknown',
    };

    // 5. Save to Firestore, with a localStorage fallback
    try {
      await addDoc(collection(firestore, '_error_logs'), payload);
      console.log('✅ Error logged successfully');
    } catch (err) {
      console.error('⚠️ Failed to log error to Firestore:', err);
      const errmessage = `Error logging failed: ${err.message}`;
      // fallback: stash in localStorage so you can retry later or inspect
      try {
        await addDoc(collection(firestore, '_error_logs'), {
          message: `Error logging failed: ${errmessage}`,
          timestamp: serverTimestamp(),
          user: 'Unknown',
        });
      } catch (lsErr) {
        console.error('❌ Failed to store error in localStorage:', lsErr);
      }
    }

    setHasError(true);
  };


  // Make sure you register it globally
  useEffect(() => {
    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", (evt) => {
      // evt.reason could be a string or an Error object
      const reason = evt.reason instanceof Error
        ? evt.reason
        : new Error(typeof evt.reason === "string" ? evt.reason : JSON.stringify(evt.reason));

      handleError(reason.message, evt.filename, evt.lineno, evt.colno, reason);
    });

    return () => {
      window.removeEventListener("error", handleError);
      // Note: can't easily remove unhandledrejection listener with anonymous fn
    };
  }, []);


  useEffect(() => {
    addEventToFirestore('Main page loaded');
  }, []);

  const variantContent = {
    A: {
      titleText: (
        <>
          Watch Hedge Funds, Institutions and Quants
          <br />
          Trade in Real Time
        </>
      ),
      subtitleText: (
        <>
          Learn to find profitable options flow patterns with the Bullflow scanner and Discord community.
        </>
      ),
    },

    B: {
      titleText: (
        <>
          Be the First to See Where
          <br />
          the Big Money is Flowing
        </>
      ),
      subtitleText: (
        <>
          Learn to find profitable options flow patterns with the Bullflow scanner and Discord community.
        </>
      ),
    },
    C: {
      titleText: (
        <>
          See Where the Big Money Trades
          <br />
          Before Everyone Else
        </>
      ),
      subtitleText: (
        <>
          Bullflow scanner and Discord community help retail traders capitalize on institutional options flow opportunities instantly.
        </>
      ),
    },
    D: {
      titleText: (
        <>
          Copy Smart Money Trades
          <br />
          Before Everyone Else
        </>
      ),
      subtitleText: (
        <>
          Bullflow scanner and Discord community help retail traders capitalize on institutional options flow opportunities instantly.
        </>
      ),
    },
  };

  // A/B/C Testing Logic
  useEffect(() => {
    try {
      // Check if variant is already stored in localStorage
      const storedVariant = localStorage.getItem('variant');
      if (storedVariant) {
        setVariant(storedVariant);
      } else {
        // Randomly assign variant 
        const variants = ['A', 'B', 'C', 'D'];
        const randomVariant = variants[Math.floor(Math.random() * variants.length)];
        setVariant(randomVariant);
        localStorage.setItem('variant', randomVariant);
      }
    } catch (error) {
      // In case of any error, set variant to A
      setVariant('C');
    }
  }, []);




  if (hasError) {
    return (
      <div style={{ color: 'red' }}>
        Something went wrong. Please contact: support@bullflow.io or DM @bullflowio on X/Twitter
      </div>
    );
  }
  return (
    <div className="app flex flex-col justify-center items-center text-white relative min-h-screen min-w-full bg-black">      <Routes>
      <Route path="/" element={
        <>
          <Helmet>
            <title>BullFlow - Real-Time Unusual Options Flow Platform</title>
            <meta name="description" content="BullFlow.io is a real-time unusual options flow tracker that provides advanced tools to view and filter options trades as they happen in the market." />
            <meta name="keywords" content="BullFlow, unusual options flow, real-time options tracker, options trading, market analysis, trading tools, historical options flow" />
            <meta property="og:title" content="BullFlow - Real-Time Unusual Options Flow Platform" />
            <meta property="og:description" content="BullFlow.io is a real-time unusual options flow tracker that provides advanced tools to view and filter options trades as they happen in the market." />
            <meta property="og:url" content={window.location.href} />
            <meta property="og:type" content="website" />
            <link rel="canonical" href={window.location.href} />
          </Helmet>
          {/* <div style={{ width: '100%', padding: '10px 20px' }}>
            <Alert
              message={
                <div style={{
                  textAlign: 'center', fontSize: '1.10rem'

                }}>
                  Memorial Day Sale! <strong>Save 25%</strong> on your first month with promo code: <strong>MEMORIAL</strong> at checkout 🚀
                </div>
              }
              type="success"
            />
          </div> */}

          <NewNavigationBar />

          <ShootingStarButton
            text="Start 7 Day Free Trial"
            onClick={() => {
              window.gtag('event', 'Start Trial Main Button', {
                event_category: 'Button',
                event_label: 'Start Trial Main Button',
                value: 1,
                variant: variant, // Include the variant in the event parameters
                dimension1: variant,
              });
              navigate('/signup');
            }}
          />
          <TitleAndSubtitle
            titleText={variantContent[variant]?.titleText || variantContent['A'].titleText}
            subtitleText={variantContent[variant]?.subtitleText || variantContent['A'].subtitleText}
          />



          <HeroHighlightComponent />
          <TitleWithCards titleText="How Does it Work?" />
          {/* <InfoCardRow /> */}
          <FullWidthVideo />
          <ScrollingImages />
          {isDesktopOrLaptop && (
            <InfiniteMovingCards
              items={cardItems}
              direction="left"
              pauseOnHover={false}
              speed="normal"
              className="custom-class-name"
            />
          )}
          {/* <LandingFAQComponent /> */}
          <CallToAction />
          <Footer />
        </>
      } />
      <Route path="/login" element={
        <>
          <Helmet>
            <title>BullFlow.io Sign In</title>
            <meta name="description" content="" />
            <meta property="og:title" content="BullFlow.io - Sign In" />
            <meta property="og:description" content="Sign in to BullFlow.io" />
            <meta property="og:url" content={window.location.href} />
            <link rel="canonical" href={window.location.href} />
          </Helmet>
          <SignInScreen />
          <Footer />
        </>
      } />
      <Route path="/updates" element={
        <>
          <NewNavigationBar />
          <UpdatesPage />
        </>
      } />
      <Route path="/TermsOfService" element={

        <>
          <NewNavigationBar />
          <TermsOfService />
        </>
      } />
      <Route path="/SignUp" element={
        <>
          <SignUpScreen />
          <Footer />
        </>
      } />
      <Route path="/PromoAuthentication" element={

        <>
          <NewNavigationBar />
          <SignInWithPromoScreen />
          <Footer />
        </>
      } />
      <Route path="/affiliates" element={

        <>
          <AffiliateInfoPage />
          <Footer />
        </>
      } />
      <Route path="/reset-password" element={

        <>
          <NewNavigationBar />
          <PasswordReset />
          <Footer />
        </>
      } />
      <Route path="/email-verification" element={

        <>
          <EmailVerification />
        </>
      } />
      <Route path="/RedeemACode" element={
        <>
          <NewNavigationBar />
          <RedeemACodeScreen />
          <Footer />
        </>
      } />
      <Route path="/api" element={
        <>
          <NewNavigationBar />
          <APIEmailCollectionComponent />
          <Footer />
        </>
      } />
      <Route path="/app" element={<MainDashboard />} />
      <Route path="/HistoricalFlow" element={<UpdatedHistoricalFlowDashboard />} />
      <Route path="/academy" element={<BullflowTrainingWithProgress />} />
      <Route path="/home" element={<HomePage />} />
      <Route path="/flow" element={<MainDashboard />} />
      <Route path="/news" element={
        <>
          <NewsPage />
        </>
      } />
      <Route path="/tester-login" element={<VladAccessPage />} />
      <Route path='/onboarding' element={<OnboardingCarousel />} />
      <Route path='/custom-flow' element={<CustomFlowWindowManager />} />
      <Route path="/historical-flow" element={<UpdatedHistoricalFlowDashboard />} />
      <Route path="/pricing" element={
        <>
          {/* <div style={{ width: '100%', padding: '10px 20px' }}>
            <Alert
              message={
                <div style={{
                  textAlign: 'center', fontSize: '1.10rem'

                }}>
                  Memorial Day Sale! <strong>Save 25%</strong> on your first month with promo code: <strong>MEMORIAL</strong> at checkout 🚀
                </div>
              }
              type="success"
            />
          </div> */}
          <NewNavigationBar />

          <NewPricingScreen />
          <Footer />
        </>
      } />
      <Route path="/NoSubscription" element={

        <>
          <NewNavigationBar />
          <NoSubscription />
          <Footer />
        </>
      } />
      <Route path="/contact" element={
        <>
          <NewNavigationBar />
          <ContactPage />
          <Footer />
        </>
      } />
      <Route path="/renew" element={

        <>
          <RenewSubscriptionScreen />
        </>
      } />
      <Route path="/verification" element={

        <>
          <NewNavigationBar />
          <SubVerification />
        </>
      } />
      <Route path="/flow-grid-testing" element={

        <>
          <VirtualizedFlowGrid />
        </>
      } />
      <Route path="/password-access" element={
        <>
          <NewNavigationBar />
          <AffiliatePasswordScreen />
          <Footer />
        </>
      } />
      <Route path="/faq" element={
        <>
          <NewNavigationBar />
          <FAQComponent />
          <Footer />
        </>
      } />
    </Routes>
      <CookieConsent
        location="bottom"
        buttonText="Got it"
        cookieName="myAppCookieConsent"
        style={{
          background: '#1c1c1e',
          color: '#f5f5f7',
          fontSize: '16px',
          padding: '16px',
          boxShadow: '0 -2px 10px rgba(0,0,0,0.2)',
        }}
        buttonStyle={{
          background: '#0a84ff',
          color: '#fff',
          fontSize: '14px',
          padding: '8px 20px',
          borderRadius: '20px',
          border: 'none',
          cursor: 'pointer',
          transition: 'background 0.3s ease',
        }}
        buttonHoverStyle={{
          background: '#0060df',
        }}
        expires={150}
      >
        We use cookies to improve the trader experience and measure site performance.
      </CookieConsent>

    </div>

    // </Router >
  );
};


export default App;
